import React from 'react';
import demo from './demo.jpg';
import '../styles/chatDetails.css';
import { MdSend } from 'react-icons/md';
import { BiPlusMedical } from 'react-icons/bi';
import { useState } from 'react';
import Button from 'antd/es/button';
import filterContext from '../context/filters/filterContext';
import { useEffect } from 'react';
import { useContext } from 'react';
import '../styles/chatDetails.css';
import { GrDocumentPdf } from 'react-icons/gr';
import pdfp from './pdff.png';

// Importing a FontAwesome icon as an example

const PreviewPage = passedref => {
	const containerStyle = {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%', // Set the desired width of the container
		height: '70%', // Set the desired height of the container
		// Add any other styling you want for the container
		backgroundColor: '#101A20',
	};
	const inputBarPreview = {
		backgroundColor: '#2c3943',
		borderRadius: '9px',
		outlineWidth: '0px',
		fontSize: '14px',
		color: '#E5E5E5',
		alignItems: 'center',
		justifyContent: 'center',
		border: 'none',
		width: '500px',
		height: '40px',
		padding: '10px',
		marginRight: '10px',
	};
	const closeButton = {
		/* Add styles for the close button */
		position: 'absolute',
		top: '150px',
		left: '770px',
		background: 'none',
		border: 'none',
		color: '#748086',
		fontSize: '35px',
		cursor: 'pointer',
		borderRadius: '25%',
	};
	const imageStyle = {
		maxWidth: '100%',
		maxHeight: '100%',
		// If you want the image to have a specific size, you can set width and height here
	};
	const inputContainer = {
		textAlign: 'center',
		backgroundColor: '#101A20',
	};
	const {
		selectedFiles,
		setSelectedFiles,
		previewURL,
		setPreviewURLs,
		handleFileSelectOfPreview,

		handleFileChange,
		inputTextImage,
		setInputTextImage,
		handletoggle,
		pimgLink,
		namePerson,
		selectedFilesPdf,
		setselectedFilesPdf,
		handlePdfFileChange,
		pstate,
		setpstate,
		pdfFileName,
		imgSent,
		setimgSent,
		setIsPreviewPageVisible,
		SendMessagewithMedia,
		handleFileSelectOfPreviewPdf,
		convId,
	} = useContext(filterContext);
	//index for dynamicing chnaging the preview  img
	const [index, setIndex] = useState(0);
	const handleInputChange = e => {
		setInputTextImage(e.target.value);
	};

	// const handleKeyPress = (event) => {
	// 	if (event.key === 'Enter') {
	// 	  // If Enter key is pressed, send the message
	// 	  handleFileSelectOfPreview();
	// 	}
	//   };
	const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
	const handleKeyPress = e => {
		if (e.key === 'Enter') {
			handleFileSelectOfPreview();
		}
	};
	const handleClosePreview = () => {
		// Add logic to handle closing the preview
		// For example, you can clear the selectedFiles and previewURLs states
		setselectedFilesPdf([]);
		setSelectedFiles([]);
		setPreviewURLs([]);
	};
	var arrofpdf = [];

	return (
		<>
			<div className="contact-navbar" onClick={handletoggle}>
				<div className="contact-info">
					<img className="profile-pic" src={pimgLink} alt="profile_picture" />
					<div className="contact-details">
						<h6 className="contact-name">{namePerson}</h6>
						<p className="contact-status">online</p>
					</div>
				</div>

				{/* Buttons */}
				{/* <div className="search-options-btns">
			  <RoundedBtn icon={<MdSearch />} />
			  <RoundedBtn icon={<HiDotsVertical />} />
		</div> */}
			</div>

			<input
				type="file"
				onChange={pstate ? handlePdfFileChange : handleFileChange}
				multiple
				style={{ display: 'none' }}
			/>

			<div style={containerStyle}>
				<div style={{ maxWidth: '600px', maxHeight: '600px' }}>
					{!pstate ? (
						<img
							src={previewURL[index]}
							style={imageStyle}
							alt="Your Image"
							className="centered-image"
						/>
					) : (
						// <p style={{color:"white"}}><GrDocumentPdf size={200} className='pdf-icon'/></p>
						<img src={pdfp} style={{ width: '200px', height: '200px' }} />
					)}
				</div>
			</div>

			<div style={inputContainer}>
				<input
					style={inputBarPreview}
					placeholder="Type a message"
					autoFocus
					onChange={handleInputChange}
					value={inputTextImage}
					onKeyDown={handleKeyPress}
				/>

				<button
					type="submit"
					className="btn"
					style={{
						fontSize: '20px',
						borderRadius: '50%',
						backgroundColor: '#202D33',
						marginRight: '20px',
					}}
					onClick={pstate ? handleFileSelectOfPreviewPdf : handleFileSelectOfPreview}
				>
					<MdSend style={{ color: 'white' }} />
				</button>
			</div>
			<button style={closeButton} onClick={handleClosePreview}>
				&#x2715; {/* Unicode for the "X" character */}
			</button>
			<div style={{ paddingTop: '35px', backgroundColor: '#101A20' }}>
				<hr
					style={{ width: '100%', color: 'white', borderTop: '2px solid grey' }}
				/>
			</div>
			<div
				style={{
					width: '100%',
					height: '200px',
					textAlign: 'center',
					paddingTop: '25px',
					backgroundColor: '#101A20',
				}}
			>
				{previewURL.map((url, index) => (
					<img
						src={pstate ? pdfp : url}
						style={{ width: '50px', height: '50px', padding: '5px' }}
						onClick={() => {
							setIndex(index);
						}}
					/>
				))}
				<Button
					shape="square" // Sets the button shape to square
					onClick={() => {
						document.querySelector('input[type=file]').click();
					}}
					icon={<BiPlusMedical color="white" />} // Use the BiPlusMedical icon as the button icon
					style={{ width: '42px', height: '42px', backgroundColor: 'transparent' }} // Customize the width and height to make it square
				/>
			</div>
		</>
	);
};

export default PreviewPage;
